import _ from 'lodash'

export default function collectFormData(form) {
  let formData = {};
  [...form.elements].forEach(input => {
    if (!input.name) return;

    if (input.type === 'radio') {
      if (input.checked) _.set(formData, input.name, input.value);
    } else {
      _.set(formData, input.name, input[input.type === 'checkbox' ? 'checked' : 'value']);
    }
    
  });

  return formData;
}